<template>
  <section>
    <base-card>
      <h3>Oh oh! Diese Seite existiert leider nicht!</h3>
      <p>Hier geht's zur Startseite.</p>
    </base-card>
  </section>
</template>